import { Component, AfterViewInit } from '@angular/core';
import { MapBaseDirective } from '../base/map.base';

import { MapService } from '../map.service';
import { HttpClient } from '@angular/common/http';
import { MapLatLng } from '../models/map.latlng';
import { MapPlace } from '../models/map.place';

declare var H: any;

@Component({
  selector: 'lib-hmap-search-movisat',
  templateUrl: './hmap-search.component.html',
  styleUrls: ['./hmap-search.component.css']
})
export class HMapSearchComponent extends MapBaseDirective implements AfterViewInit {
  private platform: any;

  // Para búsquedas sobre la cartografía
  public geoSearch = '';
  private searchTimer: any;
  private searchPoints = new Map<string, any>();
  private myLocation: any;
  private static searchCount = 0;
  public searchId = 0;

  public constructor(public mapService: MapService, public http: HttpClient) {
    super();
    this.searchId = HMapSearchComponent.searchCount < 9 ?
      HMapSearchComponent.searchCount++ : HMapSearchComponent.searchCount = 0;
  }

  ngAfterViewInit() {
    // Creo el mapa
    this.platform = new H.service.Platform({
      apikey: this.mapService.config?.hereApiKey
    });
    // Establezco el idioma del mapa y posiciono los controles
    this.switchMapLanguage();
    // Cojo mi posición aproximada según el navegador
    this.geoCoder = this.platform.getSearchService();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.myLocation = '' + position.coords.latitude + ',' + position.coords.longitude;
      });
    }
  }

  // Establezco el idioma del mapa
  switchMapLanguage() {
    this.platform.createDefaultLayers({
      lg: this.cartoType !== 'raster' ? this.lang.substring(0, 2)
        : this.getLangRaster(this.lang.substring(0, 2))
    });
  }

  // Cuando se selecciona una ubicación de la lista
  onSelectSearch(event: any) {
    const item = this.searchPoints.get(event.target.value);
    if (item) {
      const geocodingParameters: any = {
        q: item.title,
        lang: this.lang,
        limit: 1,
        at: '' + item.position.lat + ',' + item.position.lng
      }
      this.geoCoder.geocode(geocodingParameters, (result: any) => {
        if (result.items && result.items.length > 0) {
          const place = new MapPlace();
          place.Label = result.items[0].title;
          place.Street = result.items[0].address.street;
          place.PostalCode = result.items[0].address.postalCode;
          place.Locality = result.items[0].address.city;
          place.AdministrativeArea2 = result.items[0].address.county;
          place.AdministrativeArea1 = result.items[0].address.state;
          place.Country = result.items[0].address.countryName;
          place.StreetNumber = result.items[0].address.houseNumber;
          place.District = result.items[0].address.district;
          this.onMapSearch(new MapLatLng(item.position.lat, item.position.lng), place);
        }
      });
    }
    this.geoSearch = '';
  }

  // Cada vez que se escribe una letra en el buscador
  onChangeSearch(event: any) {
    try {
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        const geocodingParameters: any = {
          q: this.geoSearch,
          lang: this.lang,
          limit: 5
        }
        const sb = this.searchBounds.split(',');
        if (sb.length === 4) {
          // Restrinjo el área de busqueda preferido
          const lat0 = Number.parseFloat(sb[0]) + (Number.parseFloat(sb[2]) - Number.parseFloat(sb[0])) / 2;
          const lng0 = Number.parseFloat(sb[1]) + (Number.parseFloat(sb[3]) - Number.parseFloat(sb[1])) / 2;
          const radius = this.distanceGeo(Number.parseFloat(sb[0]), Number.parseFloat(sb[1]), lat0, lng0);
          // in: 'countryCode:ESP,ITA,FRA', // Para limitar la búsqueda por paises
          // at: this.map.getCenter().lat + ',' + this.map.getCenter().lng, // Para especificar las coordenadas alrededor
          geocodingParameters.in = 'circle:' + lat0 + ',' + lng0 + ';r=' + Math.trunc(radius);
        } else {
          if (this.myLocation) {
            geocodingParameters.at = this.myLocation;
          } else {
            geocodingParameters.at = '40.4165,-3.70256'; // Madrid
          }
        }
        const list: any = document.getElementById('hereMapSearchX' + this.searchId);
        let options = '';
        if (this.geoSearch.length > 0) {
          // this.geoCoder.geocode(geocodingParameters, (result: any) => {
          this.geoCoder.autosuggest(geocodingParameters, (result: any) => {
            if (result) {
              let words: string[] = [];
              let words2: string[] = [];
              result.items.forEach((item: any) => {
                if (words.length < 1 && item.address && item.address.label) {
                  words = item.address.label.replace(/,/g, ' ').split(' ');
                  words2 = item.address.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/,/g, ' ').split(' ');
                }
              });
              this.geoSearch = this.geoSearch.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              this.searchPoints.clear();
              words.forEach((word: string, i: number) => {
                if (word.length > 0) {
                  this.geoSearch = this.geoSearch.replace(new RegExp(words2[i], 'gi'), words[i]);
                }
              });
              result.items.forEach((item: any) => {
                if (item.address && item.address.label && !this.searchPoints.get(item.address.label)) {
                  options += '<option value="' + item.address.label + '" style="background-color: red;"/> ';
                  this.searchPoints.set(item.address.label, item);
                }
              });
              list.innerHTML = options;
            }
          });
        }
      }, 250);
    }
    catch (e) {
      console.log(e);
    }
  }

  // https://developer.here.com/documentation/map-tile/dev_guide/topics/resource-base-maptile.html
  getLangRaster(lang: string): string {
    switch (lang) {
      case 'es':
        return 'spa';
      case 'eu':
        return 'baq';
      case 'ca':
        return 'cat';
      case 'de':
        return 'ger';
      case 'en':
        return 'eng';
      case 'fr':
        return 'fre';
      case 'it':
        return 'ita';
      case 'pt':
        return 'por';
      default:
        return 'mul'; // Cada pais en su idioma
    }
    return lang;
  }
}

/*
ara – árabe
baq – euskera
cat – catalán
chi – chino (simplificado)
cht – chino (tradicional)
cze – checo
dan – danés
dut – holandés
eng – inglés
fin - finlandés
fre – francés
ger – alemán
gle – gaélico
gre – griego
heb – hebreo
hin - hindi
ind – indonesio
ita – italiano
mul – Múltiples idiomas
nor – noruego
por – persa
pol – polaco
por – portugués
rus – ruso
sin – cingalés
spa – español
swe – sueco
tha - tailandés
tur – Turco
ukr – ucraniano
urd - urdu
vie – vietnamita
wel – galés
*/